import React from 'react';
import WarningIcon from '../../../assets/WarningIcon';
import SuccessIcon from '../../../assets/SuccessIcon';
import { formatDate } from '../../../services/UtilitiesService';
import { DateMasks, NextPaymentType } from '../../../constants';
import {
  CardWrapper,
  LoanCardHeader,
  CardHeader,
  LoanHeaderTitle,
  HeaderTitle,
  LoanHeaderText,
  HeaderText,
  CardBody,
  AlertWrapper,
  AlertIcon,
  AlertText,
  PaymentScheduleWrapper,
  CardTitleLeft,
  CardTitleRight,
  HeaderIcon,
} from './Card.styles';

export const Alert = ({ type, text }: any) => {
  const styles = {
    background: type === 'warning' ? '#FFF5F5' : '#F4F8FA',
  };

  const iconType = type === 'warning' ? <WarningIcon /> : <SuccessIcon />;
  return (
    <AlertWrapper style={styles}>
      <AlertIcon data-testid="loan-card-alert-icon">{iconType}</AlertIcon>
      <AlertText data-testid="loan-card-alert-text">{text}</AlertText>
    </AlertWrapper>
  );
};

export const PaymentSchedule = ({ paymentType, nextPaymentDate }: any) => {
  if (!paymentType || !nextPaymentDate) {
    return null;
  }

  return (
    <PaymentScheduleWrapper>
      {paymentType} scheduled for{' '}
      {formatDate(nextPaymentDate, DateMasks.MonthDay)}
    </PaymentScheduleWrapper>
  );
};

export const LoanCard = ({
  alert = undefined,
  header,
  headerIcon,
  children,
}: any) => (
  <CardWrapper>
    <LoanCardHeader>
      {alert && <Alert text={alert.text} type={alert.type} />}
      <LoanHeaderTitle>
        <HeaderTitle>
          {headerIcon && (
            <HeaderIcon data-testid="loan-card-title-icon">{headerIcon}</HeaderIcon>
          )}
          <LoanHeaderText data-testid="loan-card-title">
            {header.title}
          </LoanHeaderText>
        </HeaderTitle>

        {header.nextPaymentType !== NextPaymentType.NONE && (
          <PaymentSchedule
            paymentType={header.paymentType}
            nextPaymentDate={header.nextPaymentDate}
          />
        )}
      </LoanHeaderTitle>
    </LoanCardHeader>
    <CardBody>{children}</CardBody>
  </CardWrapper>
);

const Card = ({
  dataQa,
  header,
  headerIcon,
  align = 'flex-start',
  breakpoint = '768',
  children,
}: any) => {
  const { title, statusInfo } = header;

  const cardTitle = typeof title === 'string' ? title.split('/') : title;

  const CardTitleContainer =
    cardTitle.length > 1 ? (
      <HeaderText data-testid={`${dataQa}-card-title`}>
        <CardTitleLeft>{cardTitle[0]}/</CardTitleLeft>
        <CardTitleRight>{cardTitle[1]}</CardTitleRight>
      </HeaderText>
    ) : (
      <HeaderText data-testid={`${dataQa}-card-title`}>{cardTitle}</HeaderText>
    );

  return (
    <CardWrapper>
      <CardHeader breakpoint={breakpoint} align={align}>
        <HeaderTitle>
          {headerIcon && (
            <HeaderIcon data-testid={`${dataQa}-card-title-icon`}>
              {headerIcon}
            </HeaderIcon>
          )}
          {CardTitleContainer}
        </HeaderTitle>
        {statusInfo}
      </CardHeader>
      <CardBody>{children}</CardBody>
    </CardWrapper>
  );
};

export default Card;
